<!--
 * @Descripttion: 
 * @FilePath: /mall-wap-vue/src/views/login/components/WechatButton/index.vue
 * @Author: 张兴业
 * @Date: 2020-10-09 21:46:21
 * @LastEditors: 张兴业
 * @LastEditTime: 2020-10-09 21:49:46
-->
<template>
  <div class="wechat_btn">
    <div v-if="isWechat" class="login_wechart">
      <img src="@/assets/login/wechart@2x.png" alt="" @click="wechat" />
      <div>微信登录</div>
    </div>
    <div v-if="!isWechat" class="login_wechart">
      <img src="@/assets/login/unwechart@2x.png" alt="" />
      <div class="un_wechat_text">微信登录</div>
    </div>
  </div>
</template>

<script>
import { isWechatEnv } from "@/utils";

export default {
  computed: {
    isWechat() {
      return isWechatEnv();
    }
  },
  methods: {
    wechat() {
      this.$emit("wechat");
    }
  }
};
</script>

<style lang="less" scoped>
.login_wechart {
  text-align: center;
  font-size: 12px;
  font-weight: 400;

  img {
    width: 36px;
  }

  .un_wechat_text {
    opacity: 0.261;
  }
}
</style>
